// src/slices/brandManagement/reducer.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BrandInfo, BrandManagementState } from '../../pages/BrandManagement/types';
import {
  fetchBrandInfo,
  updateBrandInfo,
  uploadLogo,
  deleteLogo,
} from './thunk';

const initialState: BrandManagementState = {
  brandInfo: null,
  loading: false,
  uploading: false,
  error: null,
};

const brandManagementSlice = createSlice({
  name: 'BrandManagement',
  initialState,
  reducers: {
    // Clear error
    clearError: (state) => {
      state.error = null;
    },
    // Update local brand info (cho preview)
    updateLocalBrandInfo: (state, action: PayloadAction<Partial<BrandInfo>>) => {
      if (state.brandInfo) {
        state.brandInfo = { ...state.brandInfo, ...action.payload };
      }
    },
    // Reset brand info
    resetBrandInfo: (state) => {
      state.brandInfo = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch brand info
    builder
      .addCase(fetchBrandInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBrandInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.brandInfo = action.payload;
      })
      .addCase(fetchBrandInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Update brand info
    builder
      .addCase(updateBrandInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBrandInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.brandInfo = action.payload;
      })
      .addCase(updateBrandInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Upload logo
    builder
      .addCase(uploadLogo.pending, (state) => {
        state.uploading = true;
        state.error = null;
      })
      .addCase(uploadLogo.fulfilled, (state, action) => {
        state.uploading = false;
        if (state.brandInfo) {
          state.brandInfo.logoUrl = action.payload.logoUrl;
        }
      })
      .addCase(uploadLogo.rejected, (state, action) => {
        state.uploading = false;
        state.error = action.payload as string;
      });

    // Delete logo
    builder
      .addCase(deleteLogo.pending, (state) => {
        state.uploading = true;
        state.error = null;
      })
      .addCase(deleteLogo.fulfilled, (state) => {
        state.uploading = false;
        if (state.brandInfo) {
          state.brandInfo.logoUrl = null;
        }
      })
      .addCase(deleteLogo.rejected, (state, action) => {
        state.uploading = false;
        state.error = action.payload as string;
      });
  },
});

export const {
  clearError,
  updateLocalBrandInfo,
  resetBrandInfo,
} = brandManagementSlice.actions;

export default brandManagementSlice.reducer;